import { Route, Routes } from "react-router-dom";

import TicketCreateScreen from "screens/App/CRM/Ticket/TicketCreateScreen";
import TicketDetailScreen from "screens/App/CRM/Ticket/TicketDetailScreen";
import TicketEditScreen from "screens/App/CRM/Ticket/TicketEditScreen";
import TicketListScreen from "screens/App/CRM/Ticket/TicketListScreen";
import { NotFoundScreen } from "screens/NotFoundScreen";

const TicketRouter = () => {
  return (
    <Routes>
      <Route path="create" element={<TicketCreateScreen />} />
      <Route path=":id/edit" element={<TicketEditScreen />} />
      <Route path=":id/detail" element={<TicketDetailScreen />} />
      <Route path="list" element={<TicketListScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default TicketRouter;
